import { ReactElement } from 'react';
import { Document, pdf } from '@react-pdf/renderer';

async function printPDF(
  document: ReactElement<React.ComponentProps<typeof Document>>,
): Promise<void> {
  const blob = await pdf(document).toBlob();
  const url = URL.createObjectURL(blob);

  const iframe = window.document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  window.document.body.appendChild(iframe);

  iframe.addEventListener('load', () => {
    iframe.contentWindow?.print();
    iframe.addEventListener('focus', () => {
      window.document.body.removeChild(iframe);
      URL.revokeObjectURL(url);
    });
  });
}

export default printPDF;
